import termsTemplate from './terms/terms.pug';
import privacyTemplate from './privacy/privacy.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider.state('terms', {
    url: '/terms',
    template: termsTemplate
  })
    .state('privacy', {
      url: '/privacy',
      template: privacyTemplate
    });
}];
